export const APP_THEMES = ['flow', 'e3dc'] as const
export type AppTheme = (typeof APP_THEMES)[number]

const BASE_LANGS = {
  English: 'en',
  German: 'de',
  Dutch: 'nl',
} as const
const THEME_LANGS = {
  flow: {
    French: 'fr',
    Italian: 'it',
    Polish: 'pl',
    Portuguese: 'pt',
    Spanish: 'es',
    Swedish: 'sv',
    Greek: 'el',
    FrenchSwitzerland: 'gsw-FR',
    GermanSwitzerland: 'gsw-CH',
  },
} as const

type ThemeLangs = typeof THEME_LANGS
type CurrentThemeLangs = ThemeLangs[keyof ThemeLangs]

const currentTheme = process.env.REACT_APP_THEME as AppTheme | undefined
const currentThemeLangs = (currentTheme ? THEME_LANGS[currentTheme as keyof ThemeLangs] : {}) as CurrentThemeLangs

export const AppLangs = {
  ...BASE_LANGS,
  ...currentThemeLangs,
} as const

export type BaseLang = 'en' | 'de' | 'nl'
export type FlowLang = BaseLang | ('fr' | 'it' | 'pl' | 'pt' | 'es' | 'sv' | 'el' | 'gsw-FR' | 'gsw-CH')
export type AppLang = BaseLang | FlowLang

export enum AppLangsNewStandard {
  English = 'eng',
  German = 'deu',
  Dutch = 'nld',
  French = 'fra',
  Italian = 'ita',
  Polish = 'pol',
  Portuguese = 'por',
  Spanish = 'spa',
  Swedish = 'swe',
  Greek = 'ell',
}

export type AppLangNewStandard = `${AppLangsNewStandard}`

export type PageAction = 'back' | 'add' | 'edit' | 'service' | 'custom'
export type Theme = 'light' | 'dark' | 'unset'

export type PageActions = {
  type: PageAction
  onClick?: () => void
  position?: 'left' | 'right'
  icon?: React.ReactNode
}[]

export interface Tab {
  name: string
  url: string
  place: number
}
export type AppName = 'e3dc' | 'hager' | 'eqoo'

export interface AppTokens {
  invitationToken?: string
  companyToken?: string
  changeEmailToken?: string
  changeEmailAndUsernameToken?: string
  giftCodeToken?: string
  protectedFileToken?: string
}

export enum TokenTypes {
  InvitationToken = 'invitationToken',
  CompanyToken = 'companyToken',
  ChangeEmailToken = 'changeEmailToken',
}

export type TokenType = `${TokenTypes}`

export interface AppState {
  title: string
  sidebarCollapsed: boolean
  tabs: Tab[]
  activeTab: number
  lang?: AppLang
  langs: AppLang[]
  translationVersions?: { [key: string]: string }
  lastPage: string
  country: string
  languageEditMode?: boolean
  app?: AppName
  moreActive: boolean
  appSettingsOpen: boolean
  isLogoutActive?: true
}

export interface AppActionPayload {
  activeTab?: number
  title?: string
  sidebarCollapsed?: boolean
  lang?: AppLang
  langs?: AppLang[]
  translationVersions?: { [key: string]: string }
  tabs?: Tab[]
  lastPage?: string
  languageEditMode?: boolean
  app?: 'hager' | 'e3dc' | 'eqoo'
  moreActive?: boolean
  appSettingsOpen?: boolean
  isLogoutActive?: true
  tokenTypeToRemove?: TokenType
}

export interface AppAction {
  type: 'APP_UPDATE' | 'ADD_TOKENS' | 'REMOVE_TOKEN'
  payload: AppActionPayload
}
